import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import EventBus from 'diagram-js/lib/core/EventBus';
import {PathwaysModeling} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {NodeType} from '@ispm/shared/bpmn-io/node-type';
import {CommandType, EventType} from '@ispm/shared/bpmn-io/bpmn-js';
import {isEmpty} from 'lodash';

export class CreateParentNodeChildrenBehavior extends CommandInterceptor {


    constructor(eventBus: EventBus, private pathwaysModeling: PathwaysModeling) {
        super(eventBus);
        super.postExecuted([EventType.SHAPE_APPEND], this.createChildrenStructure.bind(this));
        super.preExecute([CommandType.CONNECTION_APPEND], this.createChildrenStructure.bind(this));
    }

    createChildrenStructure(event) {
        const context = event.context;
        const shape = context.shape ? context.shape : context.originalSource; // if the shape result of add node or add connection
        const nodeType = ModelingUtil.getNodeType(shape);
        const connectionToTreatment = context.connection ? ModelingUtil.getNodeType(context.connection.target) === NodeType.treatment : false;
        if ((nodeType === NodeType.normal || nodeType === NodeType.neighborhood_entry || nodeType === NodeType.neighborhood_head || nodeType === NodeType.head) && !connectionToTreatment) {
            const parentNodes = context.shape ? ModelingUtil.getNodeParents(shape) : ModelingUtil.getParentsForConnectionSource(context.originalSource);
            if (parentNodes && parentNodes.length > 0) {
                parentNodes.forEach(parentElement => {
                    const parentDetails = ModelingUtil.getNodeDetails(parentElement);
                    const hasNoChildren = isEmpty(parentElement.di.bpmnElement.flowElements) ;
                   const isNotNeighborhoodEntry = parentDetails && parentDetails.nodeType !== NodeType.neighborhood_entry;

                  if (hasNoChildren &&  isNotNeighborhoodEntry) {
                        this.pathwaysModeling.createSubProcessChildren(parentElement);
                    }
                });
            }
        }
    }
}

CreateParentNodeChildrenBehavior.$inject = [...CommandInterceptor.$inject, 'pathwaysModeling'];
